import React, { createContext, useContext, useState, useCallback } from 'react';

import { useMousetrap } from 'client-web-sdk';

import Confetti from 'src/components/Confetti';

export interface ConfettiContextValue {
  triggerConfetti: () => void;
}

const ConfettiContext = createContext<ConfettiContextValue>({
  triggerConfetti: () => undefined,
});

export function ConfettiContextProvider({ children }: React.PropsWithChildren<{}>) {
  const [showConfetti, setShowConfetti] = useState(false);
  useMousetrap('up up down down left right left right b a', () => setShowConfetti(true));

  const triggerConfetti = useCallback(() => {
    setShowConfetti(true);
  }, []);

  return (
    <ConfettiContext.Provider value={{ triggerConfetti }}>
      {children}
      <Confetti showConfetti={showConfetti} setShowConfetti={setShowConfetti} />
    </ConfettiContext.Provider>
  );
}

export function useConfettiContext() {
  return useContext(ConfettiContext);
}
